import React from 'react'
import '../styles/layout/About.css'
import { Container } from 'react-bootstrap';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import EastRoundedIcon from '@mui/icons-material/EastRounded';

// The filename carries spaces, so it is encoded rather than typed pre-escaped —
// the readable form here has to keep matching the file in public/documents.
export const CERTIFICATE_URL = encodeURI('/documents/Certificate 42 Card Solutions Private Limited - 27001.pdf')

const Certifications = () => {
  return (
    <section className="certifications section section--defer section--divide">
      <Container>
        <div className="certifications__grid">
          <div className="certifications__intro reveal">
            <h2>Certification &amp; Compliance</h2>
            <span className="rule" />
            <p>
              At 42Cards, we prioritize security, trust, and regulatory alignment. Our certification
              demonstrates our commitment to safeguarding customer data and maintaining the highest
              standards of operational resilience.
            </p>
          </div>

          <article className="cert-card card-x reveal reveal--right" data-delay="1">
            <span className="chip" aria-hidden="true">
              <VerifiedUserOutlinedIcon />
            </span>
            <h3 className="card-x__title">ISO 27001 Certification</h3>
            <p className="card-x__text">
              We are ISO 27001 certified, reflecting our adherence to internationally recognized best
              practices in information security management. This certification validates that our
              processes, controls, and governance frameworks are designed to protect sensitive
              information against evolving threats.
            </p>
            <a
              className="cert-card__link"
              href={CERTIFICATE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PictureAsPdfOutlinedIcon fontSize="small" />
              <span>View certificate</span>
              <EastRoundedIcon className="cert-card__arrow" fontSize="small" />
            </a>
          </article>
        </div>
      </Container>
    </section>
  )
}

export default Certifications
